/**
 * Modules that support custom fields, named with the business's own labels
 * (e.g. "Patients" for a clinic, "Clients" for a salon).
 */
export const CUSTOM_FIELD_MODULES = [
  { key: 'customers', labelKey: 'customers', fallback: 'Customers', singularKey: 'customer', singularFallback: 'Customer' },
  { key: 'appointments', labelKey: 'appointments', fallback: 'Appointments', singularKey: 'appointment', singularFallback: 'Appointment' },
  { key: 'staff', labelKey: 'staff_plural', fallback: 'Staff', singularKey: 'staff', singularFallback: 'Staff' },
  { key: 'services', labelKey: 'services', fallback: 'Services', singularKey: 'service', singularFallback: 'Service' },
  { key: 'products', labelKey: 'products', fallback: 'Products', singularKey: 'product', singularFallback: 'Product' },
];

export const getCustomFieldModules = (tenant) =>
  CUSTOM_FIELD_MODULES.filter((m) => {
    if (!tenant?.modules) return true; // config not loaded yet: show everything
    const mod = tenant.modules[m.key];
    return m.key === 'customers' || !mod || mod.enabled;
  }).map((m) => ({
    key: m.key,
    label: tenant?.labels?.[m.labelKey] || m.fallback,
    singular: tenant?.labels?.[m.singularKey] || m.singularFallback,
  }));

/** "insurance_policy_no" -> "Insurance Policy No" for display. */
export const prettyFieldName = (label = '') =>
  String(label)
    .replace(/^cf_/, '')
    .split('_')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
